import React, { useEffect, useState } from "react";
import './GerarRemessa.css';
import { Button, Col, Collapse, DropdownItem, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import ReactSelect from "components/Form/Select/Select";
import rotas from "services/rotas";
import rest from "lib/rest";
import Swal from "sweetalert2";

const GerarRemessa = ({onClose, produtos, filial_id}) => {

  const listaPrazos = [{
    id:1,
    title:"A Vista"
  },{
    id:2,
    title:"A Prazo"
  },{
    id:3,
    title:"Negociado"
  }]
      
  const listaFilialServimed = [{
    id:1,
    title:"Matriz"
  },{
    id:2,
    title:"Filial Itumbiara (GO)"
  },{
    id:3,
    title:"Filial Jacarezinho (PR)"
  },{
    id:4,
    title:"Filial Uberaba (MG)"
  },{
    id:5,
    title:"Filial Poços de Caldas (MG)"
  },{
    id:6,
    title:"Filial Riberão das Neves (MG)"
  }]
  
  const initialFiltro = {
    prazo:[{id:"",label:""}],
    cod_faturamento:"",
    cod_farmacia:'',
    filial_servimed:'',
    fornecedor:[{id:"",label:""}]
  }

  const [isOpenCfgDist, setIsOpenCfgDist] = useState(false);
  const [filtro, setFiltro] = useState(initialFiltro);
  const [listaFornecedor, setListaFornecedor] = useState([]);

  useEffect(()=>{
    listarFornecedores();
  },[])

  const listarFornecedores = ()=>{
    const url = rotas.fornecedoresPedidos;

    const retorno = rest.get(url);

    retorno.then(ret=>{
     
    let lst = [];
      
    if(ret.success == 'S'){
      ret.lista.map(lista=>{
        lst.push({id:lista.fornecedor_id,title:lista.fornecedor})
      })     
        setListaFornecedor(lst);
      }
    })
  }

  const onChangeFiltro = (e) => {
    const { value, name } = e.target;
    let flt = { ...filtro };
    
    flt[name] = value;
    
    setFiltro(flt);
    // setFiltro({ ...filtro, [name]: value });   
  }

  const onChangeSelect = (e, name) => {
    let param = {
      type: 'select',
      target: {
        name: name,
        value: e
      }
    }
    onChangeFiltro(param);
  }
  
  const downloadFile = async (fileUrl) => {
    const nomeArq = fileUrl.split('/');

    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = nomeArq[(nomeArq.length - 1)];
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(link.href);
  }

  const gerarRemessa = () =>{
    const url = rotas.pedidoRemessa;

    const parametros = {
      filtros:filtro,
      produtos:produtos,
      filial_id:filial_id
    }

    const retorno = rest.post(url,parametros);

    retorno.then(ret=>{
      if(ret.success == 'S'){
        downloadFile(rotas.pedidoRemessa + ret.path);
      }else{
        Swal.fire('Atenção','Erro na geração do arquivo!','warning');
      }
    })
  }

  return (
    <>
      <ModalHeader>Gerar Remessa Para a Distribuidora</ModalHeader>

      <ModalBody>
        <Row>
          <Col>
            <FormGroup>
              <ReactSelect
                name="lojas"
                placeholder="Selecione a Distribuidora"
                options={listaFornecedor}
                defaultValue= {filtro.fornecedor}
                onChange={(e)=>{onChangeSelect(e,'fornecedor')}}
              ></ReactSelect>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col>
            <FormGroup className="">
              {/* <Label for="margem_apurada">Cód Faturamento</Label> */}
              <Input
                name="cod_farmacia"                
                placeholder="Cód da Farmácia"
                defaultValue={filtro.cod_farmacia}                
                onChange={onChangeFiltro}
              />
            </FormGroup>
          </Col>
          
          <Col>
            <FormGroup className="">
              {/* <Label for="margem_apurada">Cód Faturamento</Label> */}
              <Input
                name="cod_faturamento"                
                placeholder="Cód Faturamento"
                defaultValue={filtro.cod_faturamento}
                onChange={onChangeFiltro}
              />
            </FormGroup>
          </Col>

          </Row>

          <Row>

          <Col>
            <FormGroup>
              <ReactSelect
                name="prazo"
                placeholder="Selecione Prazo"
                options={listaPrazos}
                defaultValue= {filtro.prazo}
                onChange={(e) => {onChangeSelect(e,'prazo')}}
              ></ReactSelect>
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <ReactSelect
                name="filial_servimed"
                placeholder="Selecione a Filial (Servimed)"
                options={listaFilialServimed}
                defaultValue= {filtro.filial_servimed}
                onChange={(e) => {onChangeSelect(e,'filial_servimed')}}
              ></ReactSelect>
            </FormGroup>
          </Col>

        </Row>
{/* 
        <Row>
          <Col 
            style={
              {//position:'relative', 
                // height:'20px'
              }} 
                className="my-3"
          >
            <span  
              style={{
                // position:"absolute",
                //top:"50%", 
                //left:"50%", 
                //transform: 'translate(-50%, -50%)', 
                display:'block',
                height:'1px', 
                backgroundColor:'#000000'
                }}></span>

            <i 
              className= {"border rounded-circle " + (isOpenCfgDist == true ? "fa fa-chevron-up icon-filtro" : "fa fa-chevron-down icon-filtro")  } 
              onClick={()=> setIsOpenCfgDist(!isOpenCfgDist)}
              style={{
                //</Col>
                 position: 'absolute', 
                //  top: '50%', 
                 left: '97%',
                 transform: 'translate(-50%, -50%)', 
                 fontSize: '16px',
                 background: 'white',                  
                 padding: '5px'
                 }} ></i>

                 <span
                className="px-2"
                 style={{
                  //</Col>
                   position: 'absolute', 
                  //  top: '50%', 
                   left: '87%',
                   transform: 'translate(-50%, -50%)', 
                  //  fontSize: '16px',
                    background: 'white', 
                  //  padding: '5px'
                   }}
                 >Configurações</span>
          </Col>
        </Row>

          <Collapse isOpen={isOpenCfgDist}>
        <Row>
            <Col md="4">
              <FormGroup>
                <ReactSelect
                  name="lojas"
                  placeholder="Selecione a Filial (Servimed)"
                //options={lojas}
                //defaultValue= {form.fornecedor}
                //onChange={handleFilial}
                ></ReactSelect>
              </FormGroup>
            </Col>
        </Row>
         </Collapse> */}

      </ModalBody>
      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button className="bg-success" onClick={gerarRemessa}>Gerar Remessa</Button>
            <Button className="bg-danger" onClick={onClose}>Fechar</Button>
          </Col>
        </Row>

      </ModalFooter>
    </>
  );
}

export default GerarRemessa;  